var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/play") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/play",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,0 C62.09139,0 80,17.90861 80,40 C80,62.09139 62.09139,80 40,80 C17.90861,80 0,62.09139 0,40 C0,17.90861 17.90861,0 40,0 Z M31.2354913,20.1030876 C28.4740675,20.1030876 26.2354913,22.3416638 26.2354913,25.1030876 L26.2354913,25.1030876 L26.2354913,56.4259299 C26.2354913,57.4124468 26.5273219,58.3769187 27.0742501,59.1979457 C28.6051921,61.4961357 31.709317,62.1181131 34.0075071,60.5871711 L34.0075071,60.5871711 L57.517817,44.9257499 C58.068209,44.5591056 58.540398,44.0869166 58.9070424,43.5365245 C60.4379844,41.2383345 59.816007,38.1342096 57.517817,36.6032675 L57.517817,36.6032675 L34.0075071,20.9418464 C33.1864801,20.3949182 32.2220083,20.1030876 31.2354913,20.1030876 Z",
    id: "play",
    fill: "#DB7940"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.3a8962d7f8c0a638174982652c3e9c50.svg";
export { ForwardRef as ReactComponent };